// @flow
export type Insurance = "none" | "travel_basic" | "travel_plus"
export type InsuranceNumber = 0 | 1 | 2
type InsuranceNumbers = { [Insurance]: "0" | "1" | "2" }

export const INSURANCE_NAMES: { [string]: Insurance } = {
  NONE: "none",
  BASIC: "travel_basic",
  PLUS: "travel_plus",
}

export const INSURANCE_ORDERED: Array<Insurance> = ["none", "travel_basic", "travel_plus"]

export const INSURANCE_NUMBERS: InsuranceNumbers = {
  none: "0",
  travel_basic: "1",
  travel_plus: "2",
}

export const INSURANCE_NAMES_TRANSLATED = {
  [INSURANCE_NAMES.NONE]: __("booking.passenger.insurance.variant_none"),
  [INSURANCE_NAMES.BASIC]: __("booking.passenger.insurance.variant_skysilver_kiwi"),
  [INSURANCE_NAMES.PLUS]: __("booking.passenger.insurance.variant_skygold_kiwi"),
}

export const FULL_INSURANCE_NAMES_TRANSLATED = {
  [INSURANCE_NAMES.NONE]: __("booking.passenger.insurance.variant_none"),
  [INSURANCE_NAMES.BASIC]: __("booking.passenger.insurance.variant_basic"),
  [INSURANCE_NAMES.PLUS]: __("booking.passenger.insurance.variant_plus"),
}
